import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Flex, Box } from 'Components/Base';
import { SPACE } from 'Components/Theme';

import { EXAM_TYPE, EXAM_MODE, ChoicePropType } from '../../constant';

import Choice, { CHOICE_STATUS } from './Choice';

const getChoiceStatus = (mode, choice, isCorrect, isShowSolution) => {
  if (mode === EXAM_MODE.ANSWERING) return CHOICE_STATUS.NORMAL;

  if (isShowSolution) {
    if (choice.isSelected) {
      return choice.isAnswer ? CHOICE_STATUS.PASSED : CHOICE_STATUS.FAIL;
    }
    if (choice.isAnswer) {
      return CHOICE_STATUS.NOT_SELECTED;
    }
    return CHOICE_STATUS.NORMAL;
  }

  if (isCorrect) {
    if (choice.isSelected) {
      return CHOICE_STATUS.PASSED;
    }
  } else {
    if (choice.isSelected) {
      return choice.isAnswer ? CHOICE_STATUS.PASSED : CHOICE_STATUS.FAIL;
    }
    return CHOICE_STATUS.NORMAL;
  }

  return CHOICE_STATUS.NORMAL;
};

class BlockChoice extends Component {
  static propTypes = {
    onAnswer: PropTypes.func,
    choices: PropTypes.arrayOf(ChoicePropType),
    mode: PropTypes.oneOf(Object.values(EXAM_MODE)),
    isCorrect: PropTypes.bool,
    isShowSolution: PropTypes.bool,
  };

  static defaultProps = {
    onAnswer: () => {},
    choices: [],
    mode: EXAM_MODE.ANSWERING,
  };

  state = { answerValueIndexes: [-1] };

  componentDidMount() {
    this.setChoice(this.props.choices);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.choices !== nextProps.choices) {
      this.setChoice(nextProps.choices);
    }
  }

  handleChoiceChange = (choiceIndex) => {
    const { choices, type, onAnswer, isCorrect, isShowSolution } = this.props;
    if (!isCorrect && !isShowSolution) {
      const choiceId = _.get(choices, `[${choiceIndex}].id`);
      if (type === EXAM_TYPE.SINGLE_SELECTION) {
        this.setState({ answerValueIndexes: [choiceIndex] }, () => {
          onAnswer([choiceId]);
        });
      } else if (type === EXAM_TYPE.MULTIPLE_SELECTION) {
        const currentAnswerIndexes = this.state.answerValueIndexes;

        let answerValueIndexes = [];
        if (currentAnswerIndexes.includes(choiceIndex)) {
          answerValueIndexes = currentAnswerIndexes.filter(
            (answerIndex) => answerIndex !== choiceIndex
          );
          this.setState({
            answerValueIndexes,
          });
        } else {
          answerValueIndexes = currentAnswerIndexes.concat(choiceIndex);
          this.setState({
            answerValueIndexes,
          });
        }
        const answerChoices = choices.filter((c, index) => answerValueIndexes.includes(index));
        const answerIds = answerChoices.map((answer) => answer.id);
        onAnswer(answerIds);
      }
    }
  };

  setChoice = (choices) => {
    const selectedChoice = [];
    choices.forEach((choice, index) => {
      if (choice.isSelected) selectedChoice.push(index);
    });

    this.setState({
      answerValueIndexes: selectedChoice,
    });
  };

  render() {
    const { choices, type, mode, isCorrect, isShowSolution } = this.props;
    return (
      <Flex flexWrap="wrap">
        {choices.map((choice, i) => {
          return (
            <Box width={1} mb={SPACE.md} key={_.uniqueId('multipleChoice_')}>
              <Choice
                onClick={() => this.handleChoiceChange(i)}
                checked={this.state.answerValueIndexes.includes(i)}
                title={choice.value}
                type={type}
                fullWidth
                status={getChoiceStatus(mode, choice, isCorrect, isShowSolution)}
              />
            </Box>
          );
        })}
      </Flex>
    );
  }
}

export default BlockChoice;
